import { useState, useEffect } from "react";

export const MegaMenu = ({ inline }: { inline?: boolean }) => {
  const width = useWindowWidth();

  if (width >= 1024) {
    return (
      <div className={`megamenu-container ${inline ? "inline" : ""}`}>
        <div className="megamenu-placeholder">
          <span className="section-title treatments">Treatments</span>
          <a className="menu-link kidney" href="/transplant">
            Kidney Transplant
          </a>
          <a className="menu-link dialysis" href="/kidney-failure">
            Dialysis
          </a>
          <span className="section-title dialysis-options">
            Dialysis options
          </span>
          <a className="menu-link peritoneal-dialysis" href="/peritoneal-dialysis">
            Peritoneal Dialysis
          </a>
          <a className="menu-link haemodialysis" href="/kidney-failure/how-does-haemodialysis-happen">
            Haemodialysis
          </a>
          <a className="menu-link conservative-care" href="/kidney-failure/what-is-conservative-care">
            Conservative care
          </a>
          <span className="section-title access">Access</span>

          <a className="menu-link peritoneal" href="/peritoneal-dialysis">
            Peritoneal Dialysis Catheter
          </a>
          <a className="menu-link fistula" href="/fistulas">
            Arteriovenous Fistula
          </a>
          <a className="menu-link graft" href="/graft">
            Arteriovenous Graft
          </a>
          <a className="menu-link cvc" href="/line">
            Line
          </a>
          <span className="section-title procedures">Procedures</span>
          <a className="menu-link procedures-pd" href="/peritoneal-dialysis/procedures">
            Procedures
          </a>
          <a className="menu-link procedures-fistula" href="/fistulas/procedures">
            Procedures
          </a>
          <a className="menu-link procedures-graft" href="/graft/procedures">
            Procedures
          </a>
          <a className="menu-link procedures-cvc" href="/line/procedures">
            Procedures
          </a>
          <img
           style={{display: inline ? "none" : "block"}}
            className={"menu-image pointer"}
            src="/assets/images/rectangle.png"
          />
          <img
            className={"menu-image"}
            src="/assets/images/navigation-bg-2.png"
          />
        </div>
      </div>
    );
  }

  return (
    <div className={`megamenu-container ${inline ? "inline" : ""}`}>
      <div className="megamenu-placeholder">
        <ul className="tree">
          <li>
            <a href="/kidney-failure">Kidney Failure</a>
            <ul>
              <li>
                <a href="/transplant">Transplant</a>
              </li>
              <li>
                <a href="/kidney-failure">Dialysis</a>
                <ul>
                  <li>
                     <a href="/peritoneal-dialysis">Peritoneal dialysis</a>
                  </li>
                  <li>
                    <a href="/kidney-failure/how-does-haemodialysis-happen">Haemodialysis</a>
                    <ul>
                      <li>
                        <a href="/fistulas">Fistula</a>
                      </li>
                      <li>
                        <a href="/graft">Graft</a>
                      </li>
                      <li>
                        <a href="/line">Line</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              <li>
                <span>Conservative care</span>
              </li>
            </ul>
          </li>
          <li>
            <span>Procedures</span>
            <ul>
              <li>
                <a href="/peritoneal-dialysis/procedures">Peritoneal Dialysis</a>
              </li>
              <li>
                <a href="/fistulas/procedures">Arteriovenous Fistula</a>
              </li>
              <li>
                <a href="/graft/procedures">Arteriovenous Graft</a>
              </li>
              <li>
                <a href="/line/procedures">Line</a>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  );
};

function useWindowWidth() {
  const [width, setWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return width;
}

export default useWindowWidth;
